/* ============================================================
   IntactPlus - Favorite
   Salveaza handle-urile produselor in browser (localStorage).

   Daca vrei candva sincronizare intre dispozitive prin Worker,
   singurul loc de modificat sunt functiile citeste() si scrie().
   ============================================================ */

(function () {
  var CHEIE = 'ip_favorite';
  var PAGINA_FAVORITE = '/pages/favorite';

  /* ---------- stocare (singurul loc de schimbat la upgrade) ---------- */

  function citeste() {
    try {
      var brut = window.localStorage.getItem(CHEIE);
      var lista = brut ? JSON.parse(brut) : [];
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      return [];
    }
  }

  function scrie(lista) {
    try {
      window.localStorage.setItem(CHEIE, JSON.stringify(lista));
    } catch (e) {
      /* mod incognito sau spatiu plin - ignoram, nu blocam pagina */
    }
  }

  /* ---------- operatii ---------- */

  function contine(handle) {
    return citeste().indexOf(handle) !== -1;
  }

  function comuta(handle) {
    var lista = citeste();
    var pozitie = lista.indexOf(handle);
    var adaugat;

    if (pozitie === -1) {
      lista.push(handle);
      adaugat = true;
    } else {
      lista.splice(pozitie, 1);
      adaugat = false;
    }

    scrie(lista);
    actualizeazaButoane();
    actualizeazaContor();
    return adaugat;
  }

  /* ---------- interfata ---------- */

  function actualizeazaButoane() {
    var butoane = document.querySelectorAll('[data-ip-fav]');
    for (var i = 0; i < butoane.length; i++) {
      var handle = butoane[i].getAttribute('data-ip-fav');
      var activ = contine(handle);
      butoane[i].setAttribute('aria-pressed', activ ? 'true' : 'false');
      butoane[i].classList.toggle('ip-fav--activ', activ);
      butoane[i].setAttribute(
        'aria-label',
        activ ? 'Scoate de la favorite' : 'Adaugă la favorite'
      );
    }
  }

  function actualizeazaContor() {
    var numar = citeste().length;
    var contoare = document.querySelectorAll('[data-ip-fav-count]');
    for (var i = 0; i < contoare.length; i++) {
      contoare[i].textContent = numar > 0 ? numar : '';
      contoare[i].hidden = numar === 0;
    }
  }

  var cronometruToast;

  function aratToast() {
    var existent = document.getElementById('ip-fav-toast');
    if (existent) existent.remove();

    var toast = document.createElement('div');
    toast.id = 'ip-fav-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span>Adăugat la favorite</span>' +
      '<a href="' + PAGINA_FAVORITE + '">Vezi lista</a>';

    document.body.appendChild(toast);

    /* declanseaza tranzitia dupa ce elementul e in DOM */
    requestAnimationFrame(function () {
      toast.classList.add('ip-fav-toast--vizibil');
    });

    clearTimeout(cronometruToast);
    cronometruToast = setTimeout(function () {
      toast.classList.remove('ip-fav-toast--vizibil');
      setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, 300);
    }, 3000);
  }

  /* ---------- pagina cu lista ---------- */

  function formateazaPret(bani) {
    return (bani / 100).toLocaleString('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' lei';
  }

  function construiesteCard(produs) {
    var card = document.createElement('div');
    card.className = 'ip-fav-card';

    var imagine = produs.featured_image
      ? '<img src="' + produs.featured_image + '&width=400" alt="" loading="lazy">'
      : '';

    var pretVechi = '';
    if (produs.compare_at_price && produs.compare_at_price > produs.price) {
      pretVechi =
        '<s class="ip-fav-card__pret-vechi">' +
        formateazaPret(produs.compare_at_price) +
        '</s>';
    }

    card.innerHTML =
      '<a class="ip-fav-card__link" href="/products/' + produs.handle + '">' +
      '<div class="ip-fav-card__media">' + imagine + '</div>' +
      '<p class="ip-fav-card__titlu">' + produs.title + '</p>' +
      '<p class="ip-fav-card__pret">' + formateazaPret(produs.price) + ' ' + pretVechi + '</p>' +
      '</a>' +
      '<button type="button" class="ip-fav-card__scoate" data-ip-fav-remove="' +
      produs.handle + '">Scoate</button>';

    return card;
  }

  function randeazaLista() {
    var container = document.getElementById('ip-fav-lista');
    if (!container) return;

    var handles = citeste();
    var gol = document.getElementById('ip-fav-gol');

    container.innerHTML = '';

    if (handles.length === 0) {
      if (gol) gol.hidden = false;
      return;
    }
    if (gol) gol.hidden = true;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('lipsa');
          return r.json();
        })
        .then(function (produs) {
          container.appendChild(construiesteCard(produs));
        })
        .catch(function () {
          /* produsul a fost sters sau depublicat - il scoatem din lista */
          var lista = citeste().filter(function (h) {
            return h !== handle;
          });
          scrie(lista);
          actualizeazaContor();
        });
    });
  }

  /* ---------- pornire ---------- */

  function porneste() {
    actualizeazaButoane();
    actualizeazaContor();
    randeazaLista();
  }

  document.addEventListener('click', function (ev) {
    var buton = ev.target.closest('[data-ip-fav]');
    if (buton) {
      ev.preventDefault();
      ev.stopPropagation();
      var adaugat = comuta(buton.getAttribute('data-ip-fav'));
      if (adaugat) aratToast();
      return;
    }

    var scoate = ev.target.closest('[data-ip-fav-remove]');
    if (scoate) {
      ev.preventDefault();
      comuta(scoate.getAttribute('data-ip-fav-remove'));
      randeazaLista();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  /* Horizon reincarca sectiuni fara refresh de pagina */
  document.addEventListener('shopify:section:load', porneste);
})();